import React from "react";
import * as dayjs from "dayjs";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import { Button } from "@material-ui/core";
import Table, { getTextLabels } from "components/Form/Table";
import CardBox from "components/CardBox/index";

const PanhematinTable = ({
  data,
  handleOpenCRU,
  setCurrentRowObj,
  readOnly,
  handleOpenDel,
  justificationList
}) => {
  const options = {
    filter: false,
    filterType: "dropdown",
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: "none",
    search: false,
    textLabels: getTextLabels(),
  };

  const handleClick = (obj) => {
    handleOpenCRU();
    setCurrentRowObj(!obj ? null : obj);
  };

  const getRowObj = (tableMeta) => tableMeta.tableData[tableMeta.rowIndex];

  const getNameById = (list, value) => {
    if (value === null || value === undefined) return "";
    const item = list.find(x => String(x.id) === String(value));
    return item ? item.name : String(value); 
  };

  const columns = [
    {
      name: "applicationStartDate",
      label: IntlGetText("panhematin.startdate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "applicationEndDate",
      label: IntlGetText("panhematin.enddate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "pendingPrescriptionDate",
      label: IntlGetText("panhematin.pendingdate"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value ? dayjs(value).format("YYYY/MM/DD") : "",
      },
    },
    {
      name: "justificationNonFormulation",
      label: IntlGetText("panhematin.justificationNonFormulation"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => getNameById(justificationList, value),
      },
    },
    {
      name: "actions",
      label: <IntlMessages id="core.actions" />,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowObj = getRowObj(tableMeta);
          return (
            <React.Fragment>
              <Button
                onClick={() => handleClick(rowObj)}
                variant="contained"
                className="jr-btn jr-btn-xs"
                style={{ marginRight: "5px" }}
              >
                <i className="zmdi zmdi-edit"></i>
              </Button>
              {!readOnly && (
                <Button
                  onClick={() => {
                    setCurrentRowObj(rowObj);
                    handleOpenDel();
                  }}
                  variant="contained"
                  className="jr-btn jr-btn-xs"
                >
                  <i className="zmdi zmdi-delete"></i>
                </Button>
              )}
            </React.Fragment>
          );
        },
      },
    },
  ];

  return (
    <div className="row">
      <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
        <Table
          className="border-dialog-card"
          data={data}
          columns={columns}
          options={options}
        />
      </CardBox>
      {!readOnly && (
        <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
          <Button
            onClick={() => handleClick(null)}
            variant="contained"
            color="primary"
          >
            <IntlMessages id="core.add" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default PanhematinTable;